/**
 * What: Shopify integrations merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 * Provider cards on the embedded Integrations page prefer these descriptions over the
 * server registry's practitioner-facing text, so merchant copy stays package-governed.
 */
export const shopifyComponentIntegrationsCopy = {
    integrationsPage: {
        title: 'Integrations',
        settings: 'Settings',
        available: 'Available integrations',
        comingSoon: 'Coming soon',
        useExisting: 'Use an existing property',
        connectGoogle: 'Connect Google account',
        setupFailed: 'Google setup could not continue. Please try again.',
        newCollectionExplanation: 'Confirming this new property starts the usual collection of up to 60 days of available history. An existing collection keeps its current history window.',
        consentExplanation: 'Google authorization opens outside Shopify. Return here to choose a property and confirm its project link.',
        prepareAuthorization: 'Prepare Google authorization',
        continueGoogle: 'Continue to Google',
        checkAuthorization: 'Check authorization',
        checkingAuthorization: "Checking this store's authorization attempt…",
        chooseGoogleProperty: 'Choose a Google property',
        authorizationUncertain: 'Google may have accepted authorization, but confirmation was not saved. Review your organization’s integration access in TestFeed before starting another attempt.',
        authorizationFailed: 'Google authorization was cancelled or failed. Close this attempt and start again when ready.',
        authorizationPending: 'Authorization is not finished. Complete the Google window, then check again.',
        noGoogleProperties: 'No Search Console properties were returned for this Google account.',
        chooseProperty: 'Choose a property',
        chooseProject: 'Choose a project',
        confirmLink: 'Link to this store',
        close: 'Close',
        unlink: 'Unlink from this store',
        details: 'View linked data',
        vote: 'Vote for this integration',
        voted: 'Voted',
        undoVote: 'Undo vote',
        votesFailed: 'We could not save your vote. Check the saved vote before trying again.',
        notLinked: 'Not linked to this store',
        linked: 'Linked to this store',
        connected: 'Connected',
        notConnected: 'Not connected',
        needsAttention: 'Needs attention',
        reportFailed: "The last report didn't update. Try again.",
        statusLoading: 'Loading linked data…',
        statusFailed: 'We could not read the collection status. Try refreshing.',
        refresh: 'Refresh',
        paused: 'Collection paused',
        notStarted: 'No data published yet',
        collecting: 'Collecting',
        complete: 'Published history available',
        unknownCount: 'Not reported',
        activeRuns: 'Active collection runs',
        publicationPending: 'Reports awaiting publication',
        publishedReports: 'Published reports',
        storedRows: 'Stored report rows',
        latestPublished: 'Latest published date',
        unlinkExplanation: 'Unlinking removes this property from this store in the selected project. The connected Google account and collected history remain available.',
        confirmUnlink: 'Confirm unlink',
        helpLink: 'how integrations work',
        helpHeading: 'How integrations work',
        helpBody: 'Integrations bring connected data into TestFeed. Choose a property and project to use its search data for this store. Linking existing data does not start another download.',
        comingSoonHelp: 'Vote to request a coming-soon integration for your organization. You can undo your vote at any time.',
        loadProperties: 'Loading available properties…',
        missingProject: 'This store has no eligible project. Set up its project in TestFeed first.',
        missingProperty: 'No Google properties are connected to your organization yet.',
        linkExplanation: 'Confirm the property and project to use for this store.',
        propertiesFailed: 'We could not load or save these connections. Please try again.',
        googleSetupUnavailable: 'Google account setup is temporarily unavailable. You can still link an existing property.',
        organizationAccess: 'Organization account access',
        manageOrganization: 'Manage organization integrations in TestFeed',
        organizationAccessExplanation: 'Account disconnect affects the organization. Unlinking a store keeps the account and its collected history.',
        backendUnavailable: 'Integration setup is not available yet. Please try again later.',
        subtitle: "Where TestFeed's picture of your store comes from.",
        providerDescriptions: {
            shopify: 'Imports your product details and customer data to build tests.',
            posthog: 'Brings in your own analytics for extra context in your tests.',
            'google-search-console': 'Brings in your search performance data for extra context in your tests.',
        },
    },
};
//# sourceMappingURL=integrations.js.map